import {ButtonGroup, Col, Row, ToggleButton} from "react-bootstrap";
import {isMobile} from "react-device-detect";
import React from "react";

const ItemSelector = ({item, values, title, description, message, name, onChange, children}) => {
    return (
        <>
            <h4>{title}</h4>
            <p>{description}</p>
            {values && <Row>
                <Col>
                    <ButtonGroup toggle vertical={isMobile} size='md' className='mb-2' style={{width: '100%'}}>
                        {values.map((val, idx) => (
                            <ToggleButton
                                style={{
                                    minHeight: isMobile ? 'auto' : '70px',
                                    width: isMobile ? '100%' : Math.round(100 / values.length) + '%',
                                    wordWrap: 'break-word',
                                    fontSize:'18px',
                                }}
                                key={idx}
                                type='radio'
                                variant={val.value === item[name] ? 'danger' : 'outline-secondary'}
                                name='radio'
                                value={val.value}
                                checked={val.value === item[name]}
                                onChange={(e) => onChange({...item, ...{[name]: e && e.currentTarget ? e.currentTarget.value: ''}})}>
                                {val.label}
                            </ToggleButton>
                        ))}
                    </ButtonGroup>
                </Col>
            </Row>}
            {message && message}
            {
                children &&
                <Row><Col xs={12} sm={isMobile ? 6 : 12}>{children}</Col><Col xs={12} sm={6}></Col></Row>
            }
            <br/>
        </>);
};

export  default ItemSelector;
